import {
  IAddressSearchInfoCollection,
  ICoordinateInfo,
  IUtmkCoordinateInfo,
} from "@/domain/entities/address";
import { IResultData } from "@/domain/entities/shared/result";
import TYPES from "@/ioc/identifiers";
import { container } from "@/ioc/inversify.config";
import { IAddressRepository } from "@/repositories/address/addressRepository.types";
import useSetResultCodeIfNeeded from "@/use/useSetResultCodeIfNeeded";
import { defineStore } from "pinia";

const addressRepository = () => {
  return container.get<IAddressRepository>(TYPES.IAddressRepository);
};

export const useAddressStore = defineStore("address", {
  state: () => {
    return {};
  },
  getters: {},
  actions: {
    async searchAddress(
      searchKeyword: string,
      currentPage: number,
      countPerPage: number
    ) {
      const addressSearchResult: IResultData<IAddressSearchInfoCollection> = {
        isSuccess: false,
      };

      await addressRepository()
        .searchAddress(searchKeyword, currentPage, countPerPage)
        .then((result) => {
          result
            .map((resData) => {
              addressSearchResult.isSuccess = true;
              addressSearchResult.data = resData;
            })
            .mapErr((error) => {
              useSetResultCodeIfNeeded(addressSearchResult, error);
              addressSearchResult.errorMessage = error.message;
            });
        })
        .catch((error) => {
          addressSearchResult.errorMessage = error.message;
        });

      return addressSearchResult;
    },

    async getAddressCoordinate(
      dongNo: string,
      roadNo: string,
      isUnder: boolean,
      buildingMainNo: number,
      buildingSubNo: number
    ) {
      const utmkCoordinateResult: IResultData<IUtmkCoordinateInfo> = {
        isSuccess: false,
      };

      await addressRepository()
        .getAddressCoordinate(
          dongNo,
          roadNo,
          isUnder,
          buildingMainNo,
          buildingSubNo
        )
        .then((result) => {
          result
            .map((resData) => {
              utmkCoordinateResult.isSuccess = true;
              utmkCoordinateResult.data = resData;
            })
            .mapErr((error) => {
              useSetResultCodeIfNeeded(utmkCoordinateResult, error);
              utmkCoordinateResult.errorMessage = error.message;
            });
        })
        .catch((error) => {
          utmkCoordinateResult.errorMessage = error.message;
        });

      return utmkCoordinateResult;
    },

    async convertUtmkToLatLng(utmkX: string, utmkY: string) {
      const coordinateResult: IResultData<ICoordinateInfo> = {
        isSuccess: false,
      };

      await addressRepository()
        .convertUtmkToLatLng(utmkX, utmkY)
        .then((result) => {
          result
            .map((resData) => {
              coordinateResult.isSuccess = true;
              coordinateResult.data = resData;
            })
            .mapErr((error) => {
              useSetResultCodeIfNeeded(coordinateResult, error);
              coordinateResult.errorMessage = error.message;
            });
        })
        .catch((error) => {
          coordinateResult.errorMessage = error.message;
        });

      return coordinateResult;
    },
  },
});
